import { ICellRendererParams } from "@ag-grid-community/core";
import { Center, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { IRegistryDataColumn } from "../../../models/RegistryDataColumn";

interface IProps extends ICellRendererParams {
  meta?: IRegistryDataColumn;
}

export const CellFile = (props: IProps) => {
  const elem = React.useMemo(() => {
    // During edit mode, we use a dict for the value, so this needs to be parsed
    if (props.value && props.value.hasOwnProperty("filename")) {
      return props.value.filename;
    } else {
      return props.value;
    }
  }, [props.value]);

  return (
    <Stack h="full" px={2} spacing={0} whiteSpace={"pre-wrap"}>
      <Center h="full">
        <Text isTruncated={true}>{elem}</Text>
      </Center>
    </Stack>
  );
};
